import React, { useState } from 'react';
import { HexColorPicker } from 'react-colorful';
import { IconButton, Box, Popover, Typography, InputBase } from '@material-ui/core';
import EyeDropperIcon from '../../../assets/img/eyedropper.svg';
import './CustomColorPicker.scss';

const PRESETS = [null, '#E89623', '#23E8B3', '#CD94DE', '#7198EF'];

export default function CustomColorPicker({ name, value, onChange }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const emit = (newColor) => {
    onChange({ target: { name, value: newColor } });
  };

  const openEyeDropper = async () => {
    if (!window.EyeDropper) return console?.warn('EyeDropper API not supported');
    try {
      const { sRGBHex } = await new window.EyeDropper().open();
      emit(sRGBHex);
    } catch (err) {
      if (err.name === 'AbortError') return;
      console.error('EyeDropper failed:', err);
    }
  };

  return (
    <>
      <Box
        onClick={(e) => setAnchorEl(e.currentTarget)}
        style={{ backgroundColor: value }}
        className='preview-color'
      />

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          style: {
            boxShadow: '0px 3px 6px #00000029',
          },
        }}
      >
        <Box p={2}>
          <HexColorPicker color={value} onChange={emit} />

          <Box
            display='flex'
            alignItems='center'
            gridGap={8}
            style={{ marginTop: 12, flexWrap: 'nowrap' }}
          >
            <Typography
              variant='body2'
              style={{
                color: '#BDBDBD',
                whiteSpace: 'nowrap',
                fontSize: 12,
              }}
            >
              Hex
            </Typography>

            <InputBase
              value={value?.toUpperCase()}
              onChange={(e) => {
                const hexvalue = e?.target?.value?.replace(/[^0-9A-F]/gi, '')?.toUpperCase();
                emit('#' + hexvalue);
              }}
              style={{
                width: 80,
                borderBottom: '1px solid #828282',
                fontSize: 9,
              }}
              inputProps={{ maxLength: 7, style: { textAlign: 'center' } }}
            />

            <IconButton size='small' onClick={openEyeDropper} style={{ marginLeft: 'auto' }}>
              <img src={EyeDropperIcon} alt='Eye dropper' width={13} height={13} />
            </IconButton>
          </Box>

          <Box display='flex' mt={2} gridGap={8}>
            {PRESETS.map((col, i) => (
              <Box
                key={i}
                onClick={() => emit(col === null ? '#FFFFFF' : col)}
                sx={{
                  position: 'relative',
                  width: 14,
                  height: 14,
                  borderRadius: 1,
                  cursor: 'pointer',
                  backgroundColor: col || 'transparent',
                  border: col ? 'none' : '1px solid #707070',
                }}
              >
                {col === null && (
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 5,
                        width: '2px',
                        height: '100%',
                        backgroundColor: '#DE574B',
                        transform: 'rotate(45deg)',
                      },
                    }}
                  />
                )}
              </Box>
            ))}
          </Box>
        </Box>
      </Popover>
    </>
  );
}
